import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Asset } from 'src/app/interfaces/asset';
import { AdverticalService } from 'src/app/services/adverticalService/advertical.service';
import { AssetsService } from 'src/app/services/assetsService/assets.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-on-demand-catalog',
  templateUrl: './on-demand-catalog.component.html',
  styleUrls: ['./on-demand-catalog.component.less']
})
export class OnDemandCatalogComponent implements OnInit {
  ribbons: Asset[];
  constructor(private activatedRoute: ActivatedRoute, private assetsService: AssetsService, private adverticalService: AdverticalService) { }
  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.ribbons = new Array();
      this.getRibbons(this.activatedRoute.snapshot.params['id']);
      this.adverticalService.getBanner("Catalog_Banner", "CATALOG_BANNER", false);
    });
  }

  // Get catalog ribbons
  getRibbons(id) {
    this.assetsService.getCatalogRibbons({ categoryId: id }).then((resp: any) => {
      resp?.ribbons.forEach(obj => obj.style = environment.features.posterType == "h" ? "B" : "C");
      this.ribbons = resp.ribbons;
    });
  }
}